import {
  Table as MUITable,
  TableRow,
  TableBody,
  Box,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { StyledTableCell } from "./TableHeader";
import { Column } from "./Table";

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:hover": { backgroundColor: theme.palette.action.focus },
}));

export interface ITableBodyRowsProps<T> {
  columns: Column<T>[];
  rows: T[];
  onEdit?: (row: T) => void;
  onDelete?: (row: T) => void;
  customActions?: (row: T) => React.ReactNode;
}

const TableBodyRows = <T,>({
  columns,
  rows,
  onEdit,
  onDelete,
  customActions,
}: ITableBodyRowsProps<T>) => (
  <TableBody>
    {rows.map((row, idx) => (
      <StyledTableRow key={idx}>
        {columns.map((col) => (
          <StyledTableCell key={String(col.field)}>
            {col.render ? col.render(row) : (row as any)[col.field]}
          </StyledTableCell>
        ))}
        {(onEdit || onDelete || customActions) && (
          <StyledTableCell>
            <Box display="flex" justifyContent={"end"} gap={1}>
              {customActions?.(row)}
              {onEdit && (
                <IconButton
                  onClick={() => onEdit(row)}
                  size="small"
                  color="primary"
                >
                  <EditIcon />
                </IconButton>
              )}
              {onDelete && (
                <IconButton
                  onClick={() => onDelete(row)}
                  size="small"
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          </StyledTableCell>
        )}
      </StyledTableRow>
    ))}
  </TableBody>
);

export default TableBodyRows;
